import { getServiceData } from 'api';
import { getFirebaseUser } from 'api/firebase';
import getUserToken from './getUserToken';
import getRoleMe from '../role/getRoleMe';

const getUserVerification = async () => {
  const firebaseUser = getFirebaseUser();
  const initialData = {
    firebaseUser,
    role: {
      id: '',
      permissions: [],
    },
  };
  if (!firebaseUser) return initialData;
  try {
    const token = await getUserToken();
    const data = getServiceData(token);
    if (!data) {
      return initialData;
    }
    
    // Fetch role information from the separate API endpoint
    const role = await getRoleMe();
    
    return {
      firebaseUser,
      ...data,
      role: {
        ...role,
        permissions: role.permissions.map(({ name, action }) => `${name}_${action}`),
      },
    };
  } catch (e) {
    throw e;
  }
};

export default getUserVerification;
